import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import { Backdrop, Typography } from '@material-ui/core';
import { Add, TimeToLeave, Widgets } from '@material-ui/icons';

export default function SchedulingAddMobile({ isMap }) {
  const history = useHistory();

  const [isActive, setIsActive] = useState(false);

  return(
    <>
      <Backdrop
        open={isActive}
        onClick={() => setIsActive(!isActive)}
        style={{ zIndex: 1000 }}
      >
        <div style={{ position: 'fixed', bottom: 20, right: 20, zIndex: 100, display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 20 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginRight: 7.5 }}>
            <Typography variant='body2' style={{ color: '#FFFFFF' }}>
              <b>Serviço</b>
            </Typography>
            <button
              style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#FFFFFF', width: 45, height: 45, borderRadius: '50%', border: '0 none', cursor: 'pointer' }}
              onClick={() => history.push('/novo-agendamento-servico')}
            >
              <TimeToLeave style={{ color: '#13BC4B' }} />
            </button>
          </div>
          {!isMap && (
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginRight: 7.5 }}>
              <Typography variant='body2' style={{ color: '#FFFFFF' }}>
                <b>Outros</b>
              </Typography>
              <button
                style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#FFFFFF', width: 45, height: 45, borderRadius: '50%', border: '0 none', cursor: 'pointer' }}
                onClick={() => history.push('/novo-agendamento')}
              >
                <Widgets style={{ color: '#13BC4B' }} />
              </button>
            </div>
          )}
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <Typography variant='body2' style={{ color: '#FFFFFF' }}>
              <b>Novo Agendamento</b>
            </Typography>
            <button
              style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#207123', width: 60, height: 60, borderRadius: '50%', border: '0 none', cursor: 'pointer' }}
              onClick={() => setIsActive(!isActive)}
            >
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#FFFFFF', width: 25, height: 25, borderRadius: '50%' }}>
                <Add style={{ color: '#207123' }} />
              </div>
            </button>
          </div>
        </div>
      </Backdrop>
      <button
        style={{ position: 'fixed', bottom: 20, right: 20, zIndex: 100, display: isActive ? 'none' : 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#13BC4B', width: 60, height: 60, borderRadius: '50%', border: '0 none', cursor: 'pointer' }}
        onClick={() => setIsActive(!isActive)}
      >
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#FFFFFF', width: 25, height: 25, borderRadius: '50%' }}>
          <Add style={{ color: '#13BC4B' }} />
        </div>
      </button>
    </>
  );
}